import * as Actions from './actions/actions'
//@ts-ignore
import watch from 'redux-watch'
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { NavUrl } from '@alme/types/response/NavUrl';


export default class AutoNavWatcher {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;

        let autoNavWatchLocations = this._settings.stateLocations.AutoNav.watches;

        autoNavWatchLocations.forEach((loc) => {
            let watcher = watch(this._store?.getState, loc);
            this._store?.subscribe(watcher((newVal: NavUrl, oldVal: any, objectPath: string) => {
                return this.handleAutoNav(newVal, oldVal, objectPath);
            }));
        });
    }

    handleAutoNav(newVal: NavUrl, oldVal: any, objectPath: string) {
        if(!this.doesHandle(newVal)) return;

        let url = newVal.UrlAddress;
        let navType = newVal.AutoNavigationType;
        let stateLocation = this._settings.stateLocations.AutoNav.isNavigating;

        let autoNavTypes = this._settings.navConstants.autoNavTypes;

        const isDownloadLink = newVal.Metadata?.Download ? true : false;

        switch (navType) {
            case autoNavTypes.none:
                return;
                break;

            case autoNavTypes.mainPage:
                if (!this.confirmNav(newVal.UrlAddress, false)) return;
                this._store?.dispatch(Actions.navigatePage(url, navType, stateLocation));
                if(isDownloadLink){
                    this.downloadFile(newVal.UrlAddress, newVal.Metadata?.Download as string, '_self')
                }
                else{
                    if (window)
                        if (window.location)
                            window.location.href = url;
                }
                
                break;

            case autoNavTypes.popup:
                if (!this.confirmNav(newVal.UrlAddress, true)) return;
                this._store?.dispatch(Actions.navigatePage(url, navType, stateLocation));
                if(isDownloadLink){
                    this.downloadFile(newVal.UrlAddress, newVal.Metadata?.Download as string, '_blank')
                }
                else{
                    if (window)
                        window.open(url, '_blank');
                }
                
                break;
        }
    }

    doesHandle(navUrl: NavUrl) {
        if(navUrl && navUrl.AutoNavigationType && navUrl.UrlAddress)
            return true;
        return false;
    }

    confirmNav(url: any, popup: boolean) {
        if (typeof window.genWarningPopup !== "undefined") { //  checking to make sure genWarningPopup exists on this UPOINT page
            if (window.genWarningPopup == 'Y') {
                //  call UPOINT provided function and pass it the link
                //@ts-ignore
                if(popup === false)
                {
                return window.genericWarningPopup({href:url});
                }
                else
                {
                    return true;
                }
            }
            else {
                return true;
            }
        } //  end if genWarningPopup exists

        return true;
    }   //  end confirmNav

    downloadFile(fileData: string, fileName: string, target: string){
        var link = document.createElement('a');
        link.href = fileData;
        link.download = fileName;
        link.target = target
        link.click();
        link.remove()
    }
}



// WEBPACK FOOTER //
// ./modules/auto-nav-url-aon/autonav-watcher.ts